/*
 * Main
 *
 */

/* --- Import --- */
//import bootstrap from 'bootstrap';
//import { Dropdown } from 'bootstrap';
// import barba from '@barba/core';
//import '@babel/polyfill';

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { animateScrolling } from './components/animatescrolling';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

import hljs from 'highlight.js';

import 'highlight.js/styles/github-dark.css';
// first, find all the div.code blocks
document.querySelectorAll('pre code').forEach(el => {
  // then highlight each
  hljs.highlightElement(el);
});

import { darkmode } from './components/darkmode';

/* --- Load Style --- */
import '../../../rinow/src/sass/main.scss';
import '../scss/main.scss';

/* --- Dev Mode --- */

if (process.env.NODE_ENV !== 'production') {
  console.log('Looks like we are in development mode!');
}

('use strict');

// App code

/* --- Menu --- */

const menuRi = () => {
  const menuButton = document.querySelector('.navbar-toggler');
  const menuCollapse = document.querySelectorAll('.collapse');
  const menuWrapper = document.querySelector('#ri-menu');
  const searchButton = document.querySelector('#search-btn');
  const searchButtons = document.querySelectorAll('.search-btn');
  const searchWrapper = document.querySelector('#ri-search');

  if (menuButton.classList.contains('open')) {
    menuButton.classList.toggle('open');
    menuWrapper.classList.toggle('open');
    for (let m of menuCollapse) {
      m.classList.toggle('show');
    }
  }

  menuButton.addEventListener('click', (e) => {
    menuButton.classList.toggle('open');
    menuWrapper.classList.toggle('open');
    for (let m of menuCollapse) {
      m.classList.toggle('show');
    }
  });

  var i = 0,
    length = searchButtons.length;
  for (i; i < length; i++) {
    searchButtons[i].addEventListener('click', () => {
      searchButton.classList.toggle('open');
      searchWrapper.classList.toggle('open');
    });
  }
};

/* --- Scroll Effect / Small Navbar --- */
const scrollMenuBtn = () => {
  const menuNavbar = document.querySelector('#ri-menu');
  const btnTop = document.querySelector('.btn-top');
  const navbarSmall = 'navbar-small';
  const showNavbar = 'show';
  const btnNavbar = '.btn-top';

  window.addEventListener('scroll', function () {
    if (this.scrollY <= 40) {
      menuNavbar.classList.remove(navbarSmall);
      if (document.querySelector(btnNavbar) !== null) {
        btnTop.classList.remove(showNavbar);
      }
    } else {
      menuNavbar.classList.add(navbarSmall);
      if (document.querySelector(btnNavbar) !== null) {
        btnTop.classList.add(showNavbar);
      }
    }
  });

  if (document.querySelector(btnNavbar) !== null) {
    btnTop.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }
};

/* --- Menu Dashboard --- */

const allParentsLinkMenu = document.querySelectorAll('.wp-block-page-list .has-child > .wp-block-pages-list__item__link');

allParentsLinkMenu.forEach((parentLinkMenu) => {

  parentLinkMenu.addEventListener('click', function (e){
    e.preventDefault()

    /*if (this.closest('.has-child').classList.contains('active')){
      this.classList.remove('active')
    }*/

    this.closest('.has-child').classList.toggle('active');
  })

  if (parentLinkMenu.closest('.has-child').classList.contains('active')){
    parentLinkMenu.style.backgroundColor = "green"
  }
})

/* --- Init --- */

const init = () => {
  menuRi();
  scrollMenuBtn();
  darkmode();
  //tabs();
};

init();
animateScrolling();

/* --- Reload Script // Barba.js --- */
const reloadScript = () => {
  const sharedScript = document.querySelector('#shared-js');

  getScript(sharedScript);
};

const reloadScriptAsync = () => {
  return new Promise((resolve) => {
    const moduleScript = document.querySelector('#module-async-js');
    const sharedScript = document.querySelector('#shared-js');

    getScript(sharedScript);
    getScript(moduleScript);

    resolve('resolved');
  });
};

function getScript(e) {
  const bottomDOM = document.getElementsByTagName('body')[0];
  const newScript = document.createElement('script');
  newScript.type = e.type;
  newScript.src = e.src;
  newScript.id = e.id;

  e.remove();
  bottomDOM.appendChild(newScript);
}

async function asyncReloadScriptCall() {
  await reloadScriptAsync();
}

const cleanGSAP = () => {
  ScrollTrigger.getAll().forEach((t) => t.kill(false));
  ScrollTrigger.refresh();
};

const aboutInit = () => {
  cleanGSAP();
};

/* --- Barba Transition // Barba.js --- */

/*
const bodyData = document.querySelector('body').dataset;

if (!document.querySelector('#wpadminbar') && bodyData.hasOwnProperty('barba')) {
  const tl = gsap.timeline({ defaults: { ease: 'power3.inOut' } });
  const loaderSlide = 'loader-slide .trans .trans-inner';
  const loaderSlideWrap = 'loader-slide .trans';
  const loaderSlideMobile = 'loader-slide .trans-mobile';
  const loaderSlideImg = 'loader-slide .trans .trans-inner__img';

  const leaveAnimation = (e) => {
    const loaderSlide = 'loader-slide';
    const loaderSlideInner = 'loader-slide .inner';

    return new Promise(async (resolve) => {
      await tl
        .add([gsap.set(loaderSlide, { y: '0%' }), gsap.set(loaderSlideInner, { y: '-100%' })])
        .add([
          gsap.to(loaderSlide, { duration: 0.5, y: '-100%' }),
          gsap.to(loaderSlideInner, { duration: 0.5, y: '0%' }),
        ])
        .then();
      resolve();
    });
  };

  const enterAnimation = (e) => {
    return new Promise(async (resolve) => {
      resolve();
      document.documentElement.scrollTop = 0;

      await tl
        .add([
          gsap.to('loader-slide', { duration: 0.5, delay: 1, y: '-200%' }),
          gsap.to('loader-slide .inner', { duration: 0.5, delay: 1, y: '100%' }),
        ])
        .then();
    });
  };

  const leaveAnimationCustom = (e, t) => {
    //const loaderSlideInner = 'loader-slide .inner';

    if (t === 'back' || t === 'popstate' || t === 'forward') {
      barba.destroy();
    } else {
      return new Promise(async (resolve) => {
        await tl
          .add([
            gsap.set([loaderSlideWrap, loaderSlideMobile], {
              display: 'inherit',
              opacity: 1,
            }),
            gsap.set([loaderSlide, loaderSlideMobile], { y: '-100%' }),
          ])
          .add(document.querySelector('#ri-menu').classList.remove('navbar-small'))
          .add([
            gsap.to(loaderSlide, {
              duration: 1,
              y: '100%',
              transformOrigin: 'bottom left',
              stagger: 0.1,
              delay: 0.1,
            }),

            gsap.to(loaderSlideMobile, {
              duration: 1,
              y: '100%',
              transformOrigin: 'bottom left',
              delay: 0.3,
            }),
          ])
          .then();
        resolve();

        /!* await tl
          .add([
            gsap.set(loaderSlide, {
              display: 'inherit',
              opacity: 1,
            }),
          ])
          .add([
            gsap.to('loader-slide .trans .trans-inner', {
              duration: 1,
              x: '100%',
              transformOrigin: 'bottom left',
              stagger: 0.1,
              delay: 0.1,
            }),
          ])
          .then();
        resolve();*!/
      });
    }
  };

  const enterAnimationCustom = (e, t) => {
    //console.log(e);
    //console.log(t);
    if (t === 'back' || t === 'popstate') {
      barba.destroy();
      location.reload();
    } else {
      return new Promise(async (resolve) => {
        resolve();
        document.documentElement.scrollTop = 0;
        window.scrollTo(0, 0);

        if (document.querySelector('.video-wrapper video') !== null) {
          let videoBg = document.querySelector('.video-wrapper video');

          videoBg.play();
        }

        await tl
          .add([
            gsap.to(loaderSlide, {
              duration: 1,
              y: '200%',
              transformOrigin: 'bottom left',
              stagger: 0.1,
              delay: 0.1,
            }),

            gsap.to(loaderSlideMobile, {
              duration: 1,
              y: '200%',
              transformOrigin: 'bottom left',
              delay: 0.1,
            }),

            gsap.to(loaderSlideImg, {
              duration: 1,
              y: '-100%',
              transformOrigin: 'bottom left',
              delay: 0.3,
            }),
          ])
          .add([
            gsap.set([loaderSlideWrap, loaderSlideMobile], {
              display: 'none',
              opacity: 0,
            }),

            gsap.set(loaderSlideImg, {
              y: 0,
            }),
          ])
          .then();

        /!*await tl
         .add([
           gsap.to('loader-slide .trans .trans-inner', {
             duration: 1,
             x: '200%',
             transformOrigin: 'bottom left',
             stagger: 0.1,
             delay: 0.1,
           }),
         ])
         .add([
           gsap.set('loader-slide .trans', {
             display: 'none',
             opacity: 0,
           }),

           gsap.set('loader-slide .trans .trans-inner', {
             x: '-200%',
           }),
         ])
         .then();*!/
      });
    }
  };

  barba.init({
    prevent: ({ el }) => el.classList && el.classList.contains(['prevent', 'carousel__button']),
    timeout: 2000,
    //debug: true,
    transitions: [
      {
        name: 'simple-transition',
        sync: false,
        leave: ({ current, trigger }) => leaveAnimationCustom(current.container, trigger),
        enter: ({ next, trigger }) => enterAnimationCustom(next.container, trigger),
        after: ({ after, trigger }) => {
          if (trigger === 'back' || trigger === 'popstate') {
            barba.destroy();
          } else {
            asyncReloadScriptCall();
            setTimeout(aboutInit, 100);
          }
        },
      },
    ],
  });

  barba.hooks.beforeEnter((data) => {
    //asyncReloadScriptCall();
  });

  barba.hooks.after(() => {
    ga('set', 'page', window.location.pathname);
    ga('send', 'pageview');
  });
}
*/
